export const ETH_TOKEN_ADDRESSES = {
    USDT: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    USDC: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    DAI: '0x6b175474e89094c44da98b954eedeac495271d0f',
};

export const BSC_TOKEN_ADDRESSES = {
    USDC: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    BUSD: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    USDT: '0x55d398326f99059ff775485246999027b3197955',
};

export const AVAX_TOKEN_ADDRESSES = {
    USDC: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
    USDT: '0xc7198437980c041c805a1edcba50c1ce5db95118',
};

export const FTM_TOKEN_ADDRESSES = {
    USDC: '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
    DAI: '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
};

export const MATIC_TOKEN_ADDRESSES = {
    USDC: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
    USDT: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
};

export const SOL_TOKEN_ADDRESSES = {
    USDT: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    USDC: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
};
